import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { UnknownInboxItem } from 'app/modules/task-management/models/unknown-inbox-item/unknown-inbox-item.model';

interface DialogData {
  message: UnknownInboxItem;
}

interface DialogResponseData {
  message: UnknownInboxItem;
  borrower: Borrower;
}

@Component({
  selector: 'app-link-message-to-borrower-dialog',
  templateUrl: './link-message-to-borrower-dialog.component.html',
  styleUrls: ['./link-message-to-borrower-dialog.component.scss'],
  standalone: false
})
export class LinkMessageToBorrowerDialogComponent {
  valid: boolean = false;
  responseData: DialogResponseData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  linkToBorrower(borrower: Borrower) {
    if (borrower !== undefined) {
      this.valid = true;
      this.responseData = {
        ...this.responseData,
        borrower: borrower,
        message: this.data?.message,
      };
    }
  }

  messageIsEmail() {
    if (this.data?.message?.fromEmail) {
      return true;
    }
    return false;
  }

}
